import {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import {CheckCircle2} from 'lucide-react';
import {
  DealsContainer,
  DealsStatusBanner,
  SpinningLoader,
  DealsEmptyStateContainer,
  SkipAllButton,
} from './styled';

type Props = {
  isRegistrationComplete: boolean;
  registrationMessage?: string | ReactNode;
  onFinishProcess?: () => void;
};

export function DealsEmptyState({
  isRegistrationComplete,
  registrationMessage,
  onFinishProcess,
}: Props) {
  const {t} = useTranslation();

  return (
    <DealsContainer>
      <DealsStatusBanner $isComplete={isRegistrationComplete}>
        {isRegistrationComplete ? (
          <>
            <CheckCircle2 size={16} />
            <span>{registrationMessage}</span>
          </>
        ) : (
          <>
            <SpinningLoader size={16} />
            <span>{registrationMessage}</span>
          </>
        )}
      </DealsStatusBanner>
      <DealsEmptyStateContainer>
        {t('enhance_your_stay.no_deals')}
      </DealsEmptyStateContainer>
      {isRegistrationComplete && (
        <SkipAllButton onClick={onFinishProcess} variant="link">
          {t('go_back_to_home')}
        </SkipAllButton>
      )}
    </DealsContainer>
  );
}
